var heading_default = {
  "fontElementMap": "LUPeB",
  "elementSpacing": "QdIE9",
  "headerOne": "EKNhQ QdIE9",
  "headerTwo": "edXX- QdIE9",
  "headerThree": "wthqs QdIE9",
  "headerFour": "Lh1q- QdIE9",
  "headerFive": "Wpu8h QdIE9",
  "headerSix": "SekpC QdIE9",
  "child": "dBc0Z"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
